module.exports = __webpack_public_path__ + "img/58.983a3275.png";